import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '~/libs/api';
import { thunkErrorHandler } from '~/store/utils.ts';
import { TValidOtpRequest } from '~/store/otp-verification/types.ts';

export const validateOtp = createAsyncThunk(
  'otp/validateOtp',
  async (data: TValidOtpRequest, { rejectWithValue }) => {
    try {
      const response = await api.post(`/public/otp/verify`, data);
      const verificationToken = response.headers['x-verification-token'];

      return { ...response.data, verificationToken };
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);
